import { Component, model, input, OnInit, inject, ModelSignal, InputSignal } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { MailHistory } from '../../../../../../../../data/mail/models/mail-history.model';
import { PrimeTemplate } from 'primeng/api';
import { DatePipe, NgClass } from '@angular/common';
import { MailSummary } from '../../../../../../../../data/mail/models/mail-summary.model';
import { SuiviEmailsService } from '../../../../../../../../data/mail/services/suivi-emails.service';
import { Button } from 'primeng/button';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'historique-status',
    templateUrl: './historique-statuts.component.html',
    styleUrls: ['./historique-statuts.component.scss'],
    imports: [Dialog, PrimeTemplate, DatePipe, NgClass, Button],
    standalone: true
})
export class HistoriqueStatutsComponent implements OnInit {
    /**
     * Signals
     */
    visible: ModelSignal<boolean> = model(false);
    mail: InputSignal<MailSummary> = input<MailSummary>();

    /**
     * Properties
     */
    historiqueMail: MailHistory;

    /**
     * Dependencies injections
     */
    private readonly suiviEmailsService = inject(SuiviEmailsService);
    private readonly loaderService = inject(LoaderService);

    /**
     * On init component
     */
    ngOnInit() {
        this.suiviEmailsService
            .getMailHistory(this.mail()?.id)
            .pipe(this.loaderService.operator())
            .subscribe(history => {
                this.historiqueMail = {
                    ...history,
                    statuts: history.statuts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                };
            });
    }
}
